import React from "react";

function Loading() {
  return <div />;
}

export default Loading;
